<script>
import withBreakpoint from './with-breakpoint';
const defaultBreakpoints = [
    'phone',
    'tablet',
    'tabletAndBelow',
    'tabletAndAbove',
    'desktop',
    'desktopAndBelow',
    'desktopAndAbove',
    'infinite',
    'infiniteAndBelow'
];
export default {
    name: 'show-at',
    mixins: [withBreakpoint],
    props: {
        breakpoint: {
            type: String,
            required: true,
            validator: value => defaultBreakpoints.some(type => type === value)
        }
    },
    render(h) {
        let shouldRender;

        if (this.breakpoint.includes('phone') && this.currentBreakpoint === 'phone') {
            shouldRender = true;
        } else {
            shouldRender = false;
        }

        if (this.breakpoint.includes('tablet')) {
            if (this.breakpoint.includes('AndBelow') && this.currentBreakpoint !== 'desktop') {
                shouldRender = true;
            } else if (this.breakpoint.includes('AndAbove') && this.currentBreakpoint !== 'phone') {
                shouldRender = true;
            } else if (this.breakpoint === 'tablet' && this.currentBreakpoint === 'tablet') {
                shouldRender = true;
            }
        }

        if (this.breakpoint.includes('desktop')) {
            if (this.breakpoint.includes('AndBelow') && this.currentBreakpoint !== 'infinite') {
                shouldRender = true;
            } else if (this.breakpoint.includes('AndAbove') && this.currentBreakpoint !== 'tablet') {
                shouldRender = true;
            } else if (this.breakpoint === 'desktop' && this.currentBreakpoint === 'desktop') {
                shouldRender = true;
            }
        }

        if (this.breakpoint.includes('infinite')) {
            if (this.breakpoint.includes('AndBelow')) {
                shouldRender = true;
            } else if (this.currentBreakpoint !== 'infinite') {
                shouldRender = false;
            } else {
                shouldRender = true;
            }
        }

        if (shouldRender) {
            return this.$slots.default ? this.$slots.default[0] : null;
        }
        return null;
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/apps/breakpoints/show-at.vue